module.exports = __webpack_public_path__ + "static/media/checkprice.d5476a03.svg";